/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  TempID,
  TempIDOptional,
  TempIDMetaI,
  TempIDTrackedI,
} from "./temp-id";
import { TempIDTracked, TempIDMeta } from "./temp-id";

/**
 *
 * @export
 * @interface DiscountInstanceRef
 */
export interface DiscountInstanceRefOptional extends TempIDOptional {
  /**
   *
   * @type {string}
   * @memberof DiscountInstanceRef
   */
  tempID?: string;
  /**
   *
   * @type {number}
   * @memberof DiscountInstanceRef
   */
  instanceId?: number;
}

export interface DiscountInstanceRef
  extends DiscountInstanceRefOptional, TempID {
  /**
   *
   * @type {string}
   * @memberof DiscountInstanceRef
   */
  tempID?: string;
  /**
   *
   * @type {number}
   * @memberof DiscountInstanceRef
   */
  instanceId: number;
}

export interface DiscountInstanceRefTrackedI extends TempIDOptional {
  /**
   *
   * @type {string}
   * @memberof DiscountInstanceRef
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DiscountInstanceRef
   */
  instanceId?: number;
  instanceIdIsSet: boolean;
}

transformDatesMap.set(
  "DiscountInstanceRef",
  function (model: DiscountInstanceRef) {},
);

export type DiscountInstanceRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<MetaTypeBase<number>>;
}>;

export var DiscountInstanceRefMeta: DiscountInstanceRefMetaI =
  {} as DiscountInstanceRefMetaI;
DiscountInstanceRefMeta = typeMeta("DiscountInstanceRef", {
  tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
  instanceId: propertyMeta(
    "instanceId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
});

const metaI = DiscountInstanceRefMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([TempIDMeta]);
  metaI.tempID.inheritedFrom = TempIDMeta.tempID;
});

export class DiscountInstanceRefTracked
  extends TempIDTracked
  implements DiscountInstanceRefTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  instanceId__I?: number = undefined;

  get instanceIdIsSet() {
    return this.instanceId !== undefined;
  }
  set instanceIdIsSet(v: boolean) {}
  set instanceId(v: undefined | number) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  constructor(config?: DiscountInstanceRefOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;
    if (this.instanceIdIsSet == true && other?.instanceIdIsSet == true)
      return this.instanceId == other.instanceId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.instanceId) {
      this.instanceIdIsSet = true;
    }
  }
  assignFrom(
    config: DiscountInstanceRefOptional,
    options?: AssignOptions,
  ): DiscountInstanceRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = config.instanceId;
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DiscountInstanceRefTrackedI {
    const cloned = {} as DiscountInstanceRefTrackedI;
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId;
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (!isDeleted(this) && !this.instanceIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DiscountInstanceRefTrackedI {
    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;

    return this;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DiscountInstanceRefMeta.tempID,
      DiscountInstanceRefMeta,
      this.tempID,
      this,
    );
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DiscountInstanceRefMeta.instanceId,
      DiscountInstanceRefMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
